<div class="row">
    <div class="col-12">

        <form [formGroup]="memoryForm">
            <aw-wizard #wizard class="arc-wizard" navBarLocation="left">

                <aw-wizard-step stepTitle="TITOLO">
                    <div class="row">
                        <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="domanda">TITOLO*</label>
                                    <input formControlName="titolo" type="text" class="form-control" id="titolo" aria-describedby="titolo" placeholder="">
                                    <small id="titoloHelp" class="form-text text-muted">Dai un titolo al memory.</small>
                                </div>
                                <div class="form-group">
                                    <label for="sottotitolo">SOTTOTITOLO</label>
                                    <textarea  formControlName="sottotitolo" class="form-control" id="sottotitolo" aria-describedby="sottotitoloHelp"></textarea>
                                    <small id="sottotitoloHelp" class="form-text text-muted">Scrivi un'indicazione aggiuntiva</small>
                                </div>
                                <div class="form-group">
                                    <label for="info">INFO</label>
                                    <app-tinymce formControlName="info" id="info" aria-describedby="infoHelp"></app-tinymce>
                                    <small id="infoHelp" class="form-text text-muted">Inserisci le info della tua Interazione</small>
                                </div>
                                <h6>Coordinate:</h6>
                                <div class="form-group">
                                    <label for="lat">LATITUDINE</label>
                                    <input formControlName="lat" type="text" class="form-control" id="lat" aria-describedby="latHelp" placeholder="41.89884227456026">
                                    <small id="latHelp" class="form-text text-muted">Inserisci la latitudine</small>
                                </div>
                                <div class="form-group">
                                    <label for="lat">LONGITUDINE</label>
                                    <input formControlName="lng" type="text" class="form-control" id="lng" aria-describedby="lngHelp" placeholder="12.52539241745996">
                                    <small id="lngHelp" class="form-text text-muted">Longitudine</small>
                                </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateTitolo()" (click)="setTitolo()">Avanti</button>
                        </div>
                    </div>
                </aw-wizard-step>

                <aw-wizard-step stepTitle="IMMAGINI">

                    <div class="row">
                        <div class="col-12">
                            <div class="col-12" *ngIf="!interaction.interactionData">
                                <label for="domanda" class="mt-0">IMMAGINI*</label>
                                <small class="d-block">Minimo 3 immagini.</small>
                                <a href="javascript:;" class="d-block mt-3" (click)="interaction.interactionData = {risposte: [{}]}">Aggiungi la prima immagine</a>
                            </div>
                        </div>

                        <div class="col-12 mt-3" *ngIf="interaction.interactionData">
                            <div class="row mb-2" *ngFor="let risposta of interaction.interactionData.risposte; let i = index">
                                <div class="col-1 text-center text-uppercase text-primary">{{i + 1}}</div>
                                <div class="col-10">
                                    <app-media-manager [filePath]="risposta.image" (onFileSelect)="setImmagineRisposta(i, $event)"></app-media-manager>
                                </div>
                                <div class="col-1 d-flex align-items-center justify-content-center" (click)="deleteRisposta(risposta.image)">
                                    <i class="fas fa-trash"></i>
                                </div>
                            </div>
                            <a href="javascript:;" class="d-block mt-3 btn btn-default btn-sm" (click)="interaction.interactionData.risposte.push({})"><i class="fas fa-plus mr-1"></i>Aggiungi un'altra immagine</a>
                        </div>

                        <div class="col-sm-12 mt-3 d-flex justify-content-end" *ngIf="interaction.interactionData">
                            <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateRisposte()" (click)="onAddInteraction()">Salva</button>
                        </div>
                    </div>
                </aw-wizard-step>
            
            </aw-wizard>
        </form>
    </div>
</div>

<!-- {{interaction | json}} -->